import RolesState from "../api/RolesState";
import User from "../api/User";

export function canViewLicenseCalculator() {
  return Boolean(
    User.user?.is_superuser || RolesState.get_all_licensing,
  );
}
